(function(){
  'use strict';
  angular.module("irricrops")
    .directive('selectSectores', [function () {
      return {
        restrict    : 'E',
        templateUrl : 'shared/selectSectores/selectSectoresBtn.tmpl.html',
        scope       :{
          equipos           : " =equipos",
          callback          : " =?callback",
          filtros           : " =?filtros",
          disabled          : " =?ngDisabled",
          onlyOne           : " =?onlyOne",
          hideAllButton     : " =?hideAllButton",
          hideFilterButton  : " =?hideFilterButton",
          defaultText       : " =?defaultText",
          forcedText        : " =?forcedText",
          ngModel           : " =?ngModel",
          temporadas        : " =?temporadas",
          temporadaSelected : " =?modelTemporada",
        },
        controllerAs     : "ss",
        bindToController : true,
        controller       : ['$scope', '$element', '$attrs', '$timeout', '$http', '$mdDialog',
          function ($scope, $element, $attrs, $timeout, $http, $mdDialog) {

            //https://stackoverflow.com/questions/37923261/angular-1-5-component-with-ng-model/40744719#40744719
            var vm = this;

            vm.sectoresSeleccionados = vm.ngModel ? _.cloneDeep(vm.ngModel) : [];
            vm.variedades            = [];
            vm.clones                = [];
            vm.especies              = [];
            vm.portaInjertos         = [];
            vm.sistemasConduccion    = [];
            vm.calidades             = [];
            vm.isSelected            = false;

            vm.sistemaConduccionSelected = null;
            vm.clonSelected              = null;
            vm.portaInjertoSelected      = null;
            vm.especieSelected           = null;
            vm.variedadSelected          = null;
            vm.calidadSelected           = null;
            vm.buttonText                = ".";


            $scope.$watch(function() {
              return vm.ngModel;
            }, function(){
              vm.sectoresSeleccionados = vm.ngModel ? _.cloneDeep(vm.ngModel) : [];
            });


              vm.filtros = {
                items: {
                  sistemaConduccionSelected : vm.sistemaConduccionSelected,
                  clonSelected              : vm.clonSelected,
                  portaInjertoSelected      : vm.portaInjertoSelected,
                  especieSelected           : vm.especieSelected,
                  variedadSelected          : vm.variedadSelected,
                  calidadSelected           : vm.calidadSelected
                },
                onChange: function(){
                  evaluateSelection();
                  vm.runCallBack({
                    graficar : true,
                    all      : false,
                    //text     : clonSelected.nombre
                  });
                }
              };



            if(vm.callback == undefined){
              console.error("se necesita un callback");
            }




            vm.openMenu = function ($mdOpenMenu, ev) {
              vm.refreshVarCal();
              $mdOpenMenu(ev);
            };


            vm.reloadButtonText = function(){
              var text = vm.defaultText || "Seleccionar Sectores";

              if(vm.sectoresSeleccionados.length == 1){
                text = vm.sectoresSeleccionados[0].nombre;
              }

              if(vm.sectoresSeleccionados.length > 1){
                text = vm.sectoresSeleccionados.length + " Sectores";
              }

              vm.buttonText = text;
              return text;
            }
            vm.reloadButtonText();





            function isSelectable(sector, variedadSelected, calidadSelected) {
              var variedadAll = false;
              var calidadAll = false;
              if(variedadSelected === null || variedadSelected === undefined){
                variedadAll = true;
              }
              if(calidadSelected === null || calidadSelected === undefined){
                calidadAll = true;
              }
              if(calidadAll && variedadAll){
                return true;
              }
              var ret = false;
              angular.forEach(sector.variedades, function (variedad) {
                angular.forEach(variedad.calidades, function (calidad) {
                  if(variedadAll || variedad.id === variedadSelected.id) {
                    if(calidadAll || calidad.nombre === calidadSelected.nombre){
                      ret = true;
                    }
                  }
                });
              });
              return ret;
            }


            function isSelectableNew(sector, type,variable) {
              var ret = false;
              if(variable == null){
                return true;
              }
              angular.forEach(sector[type], function (item) {
                if(item.nombre == variable.nombre){
                  ret = true
                }
              });
              return ret;
            }


            function evaluateSelection(){
              angular.forEach(vm.equipos, function (equipo) {
                angular.forEach(equipo.sectores_riego, function (sector) {
                  sector.selected = false;
                  if(evaluateSector(sector)){
                    sector.selected = true;
                  }
                });
              });
            }


            function evaluateSector(sector){
              var si     = isSelectableNew(sector, "sistemas_conduccion" , vm.sistemaConduccionSelected);
              var cl     = isSelectableNew(sector, "clones" , vm.clonSelected);
              var pi     = isSelectableNew(sector, "porta_injertos" , vm.portaInjertoSelected);
              var es     = isSelectableNew(sector, "especies" , vm.especieSelected);
              var varcal = isSelectable(sector, vm.variedadSelected , vm.calidadSelected);
              if(si && cl && pi && es && varcal){
                return true;
              }
              return false;
            }



            vm.refreshVarCal = function(){
              _.each(vm.equipos, function (equipo) {
                _.each(equipo.sectores_riego, function (sector) {
                  _.each(sector.sistemas_conduccion, function (sc) {
                    if (_.find(vm.sistemasConduccion, {
                      id :sc.id
                    }) === undefined) {
                      vm.sistemasConduccion.push(sc);
                    }
                  });
                  _.each(sector.porta_injertos, function (pi) {
                    if (_.find(vm.portaInjertos, {
                      id :pi.id
                    }) === undefined) {
                      vm.portaInjertos.push(pi);
                    }
                  });
                  _.each(sector.especies, function (especie) {
                    if (_.find(vm.especies, {
                      id :especie.id
                    }) === undefined) {
                      vm.especies.push(especie);
                    }
                  });
                  _.each(sector.sistemas_conduccion, function (sc) {
                    if (_.find(vm.sistemasConduccion, {
                      id :sc.id
                    }) === undefined) {
                      vm.sistemasConduccion.push(sc);
                    }
                  });
                  _.each(sector.clones, function (clon) {
                    if (_.find(vm.clones, {
                      id :clon.id
                    }) === undefined) {
                      vm.clones.push(clon);
                    }
                  });
                  _.each(sector.variedades, function (variedad) {
                    if (_.find(vm.variedades, {
                      id : variedad.id
                    }) === undefined) {
                      //esto es porque variedad tiene calidades, y no queremos copiarlos
                      vm.variedades.push({
                        id     : variedad.id,
                        nombre : variedad.nombre
                      });
                    }
                    angular.forEach(variedad.calidades, function (calidad) {

                      if(_.find(vm.calidades,  {
                        //id : calidad.id
                            nombre: calidad.nombre
                      }) ===  undefined) {
                        vm.calidades.push(calidad);
                      }
                    });
                  });
                });
              });
            };





            vm.countSectoresNew = function(type,variable) {
              var count = 0;
              angular.forEach(vm.equipos, function (equipo) {
                angular.forEach(equipo.sectores_riego, function (sector) {
                  angular.forEach(sector[type], function (item) {
                        //if(variable == null || variable.nombre == item.nombre){
                        if(variable == null || (
                          evaluateSector(sector) &&
                          isSelectableNew(sector, type, variable)
                        )){
                          count += 1;
                      }
                    });
                });
              });
              return count;
            };





            vm.countSectores = function(variedadSelected, calidadSelected) {
              var count = 0;
              angular.forEach(vm.equipos, function (equipo) {
                angular.forEach(equipo.sectores_riego, function (sector) {
                  if(evaluateSector(sector) &&
                    isSelectable(sector, variedadSelected, calidadSelected)){
                    count += 1;
                  }
                });
              });
              return count;
            };





            vm.clear = function(equipos){

              vm.variedadSelected          = null;
              vm.calidadSelected           = null;
              vm.sistemaConduccionSelected = null;
              vm.clonSelected              = null;
              vm.portaInjertoSelected      = null;
              vm.especieSelected           = null;

              angular.forEach(equipos, function (equipoE) {
                equipoE.selected = false;
                angular.forEach(equipoE.sectores_riego, function (sectorE) {
                  sectorE.selected = false;
                });
              });
              getSectoresSeleccionados(vm.equipos);
            };




            //para menu de filtros
            vm.select = function (type,itemSelected) {
              //vm.clear(vm.equipos);
              vm[type] = null;
              if(itemSelected !== null && itemSelected !== undefined){
                vm[type] = itemSelected;
              }
              evaluateSelection();
              getSectoresSeleccionados ();
              vm.runCallBack({
                graficar : true,
                all      : false,
                //text     : clonSelected.nombre
              });
            };



            var getSectoresSeleccionados = function (equipos,returnObject) {
              vm.sectoresSeleccionados = [];
              vm.sectoresSeleccionadosIds = [];
              angular.forEach(equipos, function (equipo) {
                angular.forEach(equipo.sectores_riego, function (sector) {
                  if (sector.selected) {
                    vm.sectoresSeleccionadosIds.push(sector.id);
                    vm.sectoresSeleccionados.push(sector);
                  }
                });
              });

              if(returnObject){
                return vm.sectoresSeleccionados;
              }
              return vm.sectoresSeleccionadosIds;
            };





            vm.clearSelect = function () {
              vm.clear(vm.equipos);
              vm.runCallBack({
                graficar : true,
                all      : false,
                clear    : true
              });
            }

            vm.selectAll = function () {
              vm.clear(vm.equipos);
              vm.runCallBack({
                all      : true,
                graficar : true
              });
            };


            vm.runCallBack = function(answer){
              refreshApi();
              //vm.ngModel = null;
              if (answer.graficar) {
                if(answer.all || answer.clear){
                  vm.isSelected = false;
                }else{
                  vm.isSelected = true;
                }
                var seleccionados =  getSectoresSeleccionados(vm.equipos, true);
                var  seleccionadosIds = getSectoresSeleccionados(vm.equipos);
                answer = _.merge(answer, {
                  seleccionadosIds: seleccionadosIds,
                  seleccionados   : seleccionados,
                  temporadaSelected : vm.temporadaSelected
                });
                if(vm.ngModel !== undefined){
                  if(vm.onlyOne && seleccionados.length > 0){
                    vm.ngModel = seleccionados[0];
                  }else{
                    vm.ngModel = seleccionados;
                  }
                }
                vm.reloadButtonText();
                $timeout(function(){
                  vm.callback(answer);
                }, 300); //HACK
              }
            };

            vm.changeTemporada = function(temporada){
                  vm.runCallBack({
                    graficar: true
                  });
            }



            function refreshApi(){
              vm.filtros = {
                items: {
                  sistemaConduccionSelected : vm.sistemaConduccionSelected,
                  clonSelected              : vm.clonSelected,
                  portaInjertoSelected      : vm.portaInjertoSelected,
                  especieSelected           : vm.especieSelected,
                  variedadSelected          : vm.variedadSelected,
                  calidadSelected           : vm.calidadSelected
                },
                onChange: function(items){

                  vm.sistemaConduccionSelected = items.sistemaConduccionSelected;
                  vm.clonSelected              = items.clonSelected;
                  vm.portaInjertoSelected      = items.portaInjertoSelected;
                  vm.especieSelected           = items.especieSelected;
                  vm.variedadSelected          = items.variedadSelected;
                  vm.calidadSelected           = items.calidadSelected;

                  evaluateSelection();
                  vm.runCallBack({
                    graficar : true,
                    all      : false,
                  });
                }
              };
            }












            // -------------------------------------------------
            // --------------- Dialog --------------------------
            // -------------------------------------------------



            vm.showSelectSectores = function (ev) {

              vm.refreshVarCal();
              vm.clear(vm.equipos);

              var parent = document.getElementsByClassName('md-dialog-container')[0];

              if(parent == null){
                parent = angular.element(document.body);
              }

              $mdDialog.show({
                multiple            : true,
                controller          : DialogController,
                controllerAs        : "dd",
                templateUrl         : 'shared/selectSectores/selectSectores.tmpl.html',
                parent              : parent,
                targetEvent         : ev,
                clickOutsideToClose : true,
                bindToController    : true,
                locals              : {
                  equipos     : vm.equipos,
                  calidades   : vm.calidades,
                  variedades  : vm.variedades,
                  clear       : vm.clear,
                  onlyOne     : vm.onlyOne,
                  defaultText : vm.defaultText,
                  forcedText  : vm.forcedText,
                  ngModel: vm.ngModel
                }
              })
                .then(function (answer) {
                  vm.runCallBack(answer);
                }, function () {

                });//END then
            };











            var DialogController = ["$scope", "$mdDialog", "equipos", function ($scope, $mdDialog) {

              var vm                   = this;
              vm.searchText            = "";
              vm.equiposEdicion        = angular.copy(vm.equipos);
              vm.sectoresSeleccionados = [];
              vm.showCalidad           = null;
              vm.showVariedad          = null;


              vm.getSectoresSeleccionados = function(){
                //ejecuta la funcion global, pero actualizando ambas variables de sectoresSeleccionados
                //tanto del Ctrl externo como del Dialog
                vm.sectoresSeleccionados = getSectoresSeleccionados(vm.equiposEdicion);
              }



              if(vm.ngModel && vm.ngModel.length > 0){
                angular.forEach(vm.equiposEdicion, function (equipo) {
                  angular.forEach(equipo.sectores_riego, function (sector) {
                    if(vm.ngModel.find(s => s.id == sector.id)){
                      sector.selected = true;
                    }
                  });
                });
                vm.getSectoresSeleccionados();
              }

              angular.forEach(vm.equiposEdicion, function (equipo) {
                angular.forEach(equipo.sectores_riego, function (sector) {
                  sector.show = true;
                });
              });


              vm.selectEquipo = function (equipo) {
                if(vm.onlyOne){
                  return;
                }
                if (equipo.selected === undefined) {
                  equipo.selected = false;
                }
                equipo.selected = !equipo.selected;
                angular.forEach(equipo.sectores_riego, function (sector) {
                  sector.selected = equipo.selected;
                });
                vm.getSectoresSeleccionados();
              };

              vm.selectVariedad = function (variedadSelected) {
                var showAll = false;
                if(variedadSelected !== null){
                  vm.showVariedad = variedadSelected;
                }else{
                  vm.showVariedad = null;
                  showAll = true;
                }
                angular.forEach(vm.equiposEdicion, function (equipo) {
                  angular.forEach(equipo.sectores_riego, function (sector) {
                    sector.show = true;
                    if(!isSelectable(sector,variedadSelected,null) && !showAll){
                      sector.show = false;
                    }
                  });
                });
                //vm.getSectoresSeleccionados();
              };

              vm.selectCalidad = function (calidadSelected) {
                var showAll = false;
                if(calidadSelected !== null){
                  vm.showCalidad = calidadSelected;
                }else{
                  vm.showCalidad = null;
                  showAll = true;
                }
                angular.forEach(vm.equiposEdicion, function (equipo) {
                  angular.forEach(equipo.sectores_riego, function (sector) {
                    angular.forEach(sector.variedades, function (variedad) {
                      angular.forEach(variedad.calidades, function (calidad) {
                        sector.show = true;
                        if (calidad.id !== calidadSelected.id && !showAll) {
                          sector.show = false;
                        }
                      });
                    });
                  });
                });
                //vm.getSectoresSeleccionados();
              };

              vm.selectCalidadByName = function(calidadSelected){
                var showAll = false;
                if(calidadSelected !== null){
                  vm.showCalidad = calidadSelected; //STRING
                }else{
                  vm.showCalidad = null;
                  showAll = true;
                }
                angular.forEach(vm.equiposEdicion, function (equipo) {
                  angular.forEach(equipo.sectores_riego, function (sector) {
                    sector.show= true;
                    if(!isSelectable(sector, null,calidadSelected) && !showAll){
                      sector.show = false;
                    }
                  });
                });
                //vm.getSectoresSeleccionados();
              }

              vm.isEquipoIndeterminate = function (equipo) {
                var allChecked     = true;
                var nothingChecked = true;
                angular.forEach(equipo.sectores_riego, function (sector) {
                  if (!sector.selected) {
                    allChecked = false
                  }
                  if (sector.selected) {
                    nothingChecked = false
                  }
                });
                return !allChecked && !nothingChecked;
              }

              vm.isEquipoChecked = function (equipo) {
                var allChecked = true;
                angular.forEach(equipo.sectores_riego, function (sector) {
                  if (!sector.selected) {
                    allChecked = false
                  }
                });
                return allChecked;
              };

              vm.openMenu = function ($mdOpenMenu, ev) {
                $mdOpenMenu(ev);
              };

              vm.clearSelected = function(){
                vm.clear(vm.equiposEdicion);
                vm.getSectoresSeleccionados();
              }
              //vm.clearSelected();

              $scope.cancel = function () {
                $mdDialog.cancel();
              };

              $scope.aceptar = function () {
                angular.forEach(vm.equipos, function (equipo) {
                  angular.forEach(vm.equiposEdicion, function (equipoE) {
                    if (equipoE.id == equipo.id) {
                      equipo.selected = equipoE.selected;
                    }
                    angular.forEach(equipo.sectores_riego, function (sector) {
                      angular.forEach(equipoE.sectores_riego, function (sectorE) {
                        if (sector.id == sectorE.id) {
                          sector.selected = sectorE.selected;
                        }
                      });
                    });
                  });
                });
                $mdDialog.hide({graficar : true});
              };

              $scope.all = function () {
                vm.clear(vm.equiposEdicion);
                $mdDialog.hide({graficar : true, all: true});
              }

              vm.select = function(sector){
                if(vm.onlyOne){
                  vm.selectOnlyOne(sector);
                }else{
                  sector.selected = !sector.selected;
                }
              }

              vm.selectOnlyOne = function (sector) {
                if(vm.onlyOne){
                  vm.clear(vm.equiposEdicion);
                  vm.getSectoresSeleccionados();
                  sector.selected = true;
                  $scope.aceptar();
                }
              };


            }];
            //END DialogController






          }]
      };
    }]);
})();
